import React from 'react';
import "./Vibration.css";

function Vibration() {
  return (
    <div className='vibration-container'>
      <div className="vibration-content">

        <div className='vibration-header'>
          <h3>TİTREŞİM ÖNLEME KAUÇUK HAMURLARI</h3>
        </div>
        <div className='pro-text-promotion'>
          <h3>TİTREŞİM ÖNLEME KAUÇUK HAMURLARI</h3>
          <p> Makine veya tesislerin ürettiği titreşimler birçok alanda rahatsız edici ve hatta bazen sağlık açısından tehlikelidir. Anti-vibrasyon parçaları makine, motor veya yoldan kaynaklanan titreşimlerin filtre edilerek uygulama alanında konforun iyileştirilmesi için kullanılırlar. Anti-vibrasyon parçalarındaki performans kriterlerinde en büyük parametre doğru hamur seçimidir. Geliştirme aşamasında doğru hamur seçimi yaparak maliyetleri önemli ölçüde azaltmak, bakımı kademeli hale getirmek ve uygulamanın ömrünü artırmak mümkündür.
          </p>
          <p>High PCK, titreşim önleyici çözümler konusunda uzmandır. Üstün uygulama bilgi birikimi ve geniş karışım yelpazesi ile, ister mevcut reçetelerimizden biri ister müşteriye özel bir çözüm olsun, her türlü koşula uygun maliyetli bir çözüm sağlayabiliriz.</p>
          <p>Geçtiğimiz birkaç yılda High PCK inşaat ve tarım makinelerinde, traktörlerde ve özel araçlarda motorların ve kabinlerin süspansiyonu ve yalıtımı gibi çok çeşitli uygulamalar için yüzlerce farklı "yüksek verimli" kauçuk hamur tasarladı ve ürünlerinde hedeflenen sonuçlar alındı. Jeneratörler, kompresörler, rüzgar türbinleri, demiryolu bojileri, otobüs süspansiyonları için birçok firma ile çözüm ortağı olarak çalışıldı.</p>

        </div>




        <div className='vibration-features'>
          <div className='vibration-features-header'>
            <h3>ÜRÜN ÖZELLİKLERİ</h3>
          </div>
          <p><strong>Elastomer :</strong>NR, SBR, BR, IR, NBR, CR, EPDM bazlı hamurlar
            Sertlik: 40-85 ShA</p>
          <p><strong>Sertlik :</strong>40-80 ShA</p>
          <p><strong>Çapraz Bağlama :</strong>Kükürt, peroksit ya da amin pişirici</p>
          <p><strong>Üretim Metodu :</strong>Enjeksiyon ve Kompresyon süreçleri ile uyumlu</p>
          <p><strong>Kullanım Alanları :</strong>Otomotiv, denizcilik, endüstriyel ekipmanlar, tarım ve iş makineleri, savunma sanayi, raylı sistemler ve yenilenebilir enerji sektörlerinde kullanılmaktadır.</p>
        </div>



        <div className='info-contact'>
          <button className='btn-contact'>Teklif almak için bizimle iletişime geçebilirsiniz</button>
        </div>

      </div>
    </div>
  )
}

export default Vibration